/**
 * A service to implement functions related to Customer Purchases:
 * 1 - the function to get all the Customer Purchases of the authenticated user. This function enables setting
 * parameters to the URL;
 * 2 - the function to get the attributes of the identified Customer Purchase: id, code, document identifier,
 * creation date, total amount, status, store, shipping information and the ordered Items.
 */

import {apiFetch} from '@/_helpers';


export const ordersService = {
    getAll,
    get,
    getOrderPaymentStatus
};


/**
 *  A function to get all the Customer Purchases of the authenticated user. This function enables setting parameters
 *  to the URL. Right now, the parameters are used to:
 *  (1) obtain the Customer Purchases' of the authenticated user of a specific year (param=year);
 *  (2) to get the next Customer Purchases' of the authenticated user, of the paginated service.
 *
 * @param params
 * @returns {*}
 */
function getAll(params) {
    let str = Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&');

    return apiFetch("customerspurchases/?" + str);
}


/**
 * A function to get the attributes of the identified Customer Purchase: id, code, document identifier, creation date,
 * total amount, status, store, shipping information and the ordered Items.
 *
 * @param pk
 * @returns {*}
 */
function get(pk) {
    return apiFetch("customerspurchases/" + pk + "/");
}


/**
 *  A function to obtain the payment information of a Customer Purchase. This function is called on the resume of a
 *  Customer Purchase, where the user is informed whether or not the Payment is being validated or where the user can
 *  check the data to pay the Customer Purchase.
 *
 * @param pk
 * @returns {*}
 */
function getOrderPaymentStatus(pk) {
    return apiFetch("customerspurchases/" + pk + "/payment/");
}
